module.exports = __webpack_public_path__ + "static/media/location-arrow.f11f5e8d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/vectors/location-arrow.svg
// module id = 553
// module chunks = 0